<result>
  <p>{ props.result }</p>
  <div class="link-group">
    <a class="back-page-txt" href="#{props.shopId }"><i class="fas fa-angle-double-left"></i>ログイン画面へ戻る</a>
  </div>
  <script>
    import { router } from '@riotjs/route';

    export default {
      onMounted(props) {
        if (props.result === '') {
          router.push('point/#' + props.shopId);
        }
      }
    };
  </script>
  <style type="postcss">
    @media (max-width: 640px) {
      p {
        margin: 0;
        padding: 17px;
        border: 1px solid #e2e8f0;
        border-radius: 5px;
        background: #f8fafc;
        color: #202938;
        font-size: 0.7rem;
        font-weight: 700;
        overflow-wrap: anywhere;
      }

      .link-group {
        margin-top: 17px;
      }
    }
  </style>
</result>